import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
    UserCog, Trash2, FileSearch, History, Sparkles, Building2, LineChart,
    CalendarClock, DoorOpen, Landmark, ReceiptText, Clock, PieChart, Tablet,
    ListTree, ClipboardList, Radiation, FileSignature,
    BadgeCheck, Activity,
} from 'lucide-react';
import '../styles/Amministrazione.css';

/**
 * Amministrazione — quello che serve a chi amministra, non a chi
 * lavora tutto il giorno.
 *
 * Sono riquadri che portano alle schermate esistenti, non una pagina
 * che le contiene: cosi' ognuna resta raggiungibile anche per conto
 * suo, e aggiungerne una non richiede di toccare le altre.
 */

const VOCI = [
    {
        gruppo: 'Persone e accessi',
        voci: [
            { path: '/utenti', Icona: UserCog, titolo: 'Utenti',
              testo: 'Chi entra nel gestionale, con quale ruolo e quali permessi.' },
            { path: '/registro-accessi', Icona: FileSearch, titolo: 'Accessi',
              testo: 'Chi ha guardato cosa, e quando.' },
            { path: '/registro-modifiche', Icona: History, titolo: 'Modifiche',
              testo: 'Ogni variazione ai dati, con autore e valore precedente.' },
            { path: '/area-dipendenti', Icona: Clock, titolo: 'Presenze',
              testo: 'Organico, timbrature, ferie, buste paga e il file per lo studio paghe.' },
            { path: '/cestino', Icona: Trash2, titolo: 'Cestino',
              testo: 'Cio\u2019 che e\u2019 stato cancellato, e come rimetterlo.' },
        ],
    },
    {
        gruppo: 'Cartella clinica',
        voci: [
            { path: '/campi', Icona: ListTree, titolo: 'Catalogo dei campi',
              testo: 'Cosa si misura e in che unita\u2019: un campo si definisce una volta sola, e le schede lo pescano da qui.' },
            { path: '/schede-cliniche', Icona: ClipboardList, titolo: 'Schede cliniche',
              testo: 'Le schede della struttura: sezioni, campi, ordine. Anche la segreteria puo\u2019 attivarle e ordinarle.' },
            { path: '/validazione-campi', Icona: FileSignature, titolo: 'Validazione dei campi',
              testo: 'A che punto \u00e8 la firma dei dieci documenti che descrivono i campi clinici: chi firma, chi legge, da quanto \u00e8 fuori.' },
            { path: '/registro-rx', Icona: Radiation, titolo: 'Registro RX',
              testo: 'Prestazioni fatturate in proprio dai medici e quota riconosciuta alla struttura. Non entra nei conteggi della clinica.' },
        ],
    },
    {
        gruppo: 'Strumenti',
        voci: [
            /* «Assistenza» si chiamava come il pulsante fluttuante che
               risponde alle domande sui manuali, ed e' un'altra cosa: quello
               spiega come si fa, questo dice quanto costa. Due schermate con
               lo stesso nome sono una schermata che nessuno trova. */
            /* Sta qui e non nel menu principale: e' la prima cosa che si
               apre dopo un allarme su Telegram, e chi arriva la cerca
               dove stanno gli altri strumenti di chi amministra. */
            { path: '/stato-sistema', Icona: Activity, titolo: 'Stato del sistema',
              testo: 'Backup, lavori notturni, scadenze dei certificati, spazio e allarmi.' },
            { path: '/assistenza-admin', Icona: Sparkles, titolo: 'Consumi dell\'assistente AI',
              testo: 'Compiti attivi, spesa del mese, tetto e costi da scalare ai medici.' },
            { path: '/soggetti', Icona: Building2, titolo: 'Aziende',
              testo: 'I soggetti a cui si intestano le fatture.' },
            { path: '/orari', Icona: CalendarClock, titolo: 'Orari',
              testo: 'Quando lavora ciascuno: giorni, fasce e stanze.' },
            { path: '/stanze', Icona: DoorOpen, titolo: 'Stanze',
              testo: 'Studi e apparecchiature, con il colore che li identifica in agenda.' },
            { path: '/dispositivi', Icona: Tablet, titolo: 'Tablet',
              testo: 'I dispositivi con l\u2019ultimo contatto, la chiave nuova quando serve, e le compilazioni rimaste a met\u00e0 da annullare.' },
            { path: '/albi', Icona: BadgeCheck, titolo: 'Albi e sedi',
              testo: 'Le liste da cui si sceglie l\u2019iscrizione all\u2019albo di un professionista: gli albi sono fissi, le sedi si aggiungono quando servono.' },
        ],
    },
    {
        gruppo: 'Andamento',
        voci: [
            { path: '/controllo-gestione', Icona: LineChart, titolo: 'Controllo di gestione',
              testo: 'Saldi, costi e compensi: quanto resta a fine mese.' },
            { path: '/analisi', Icona: PieChart, titolo: 'Analisi dei dati',
              testo: 'Quanto rende ogni specialit\u00e0, da dove vengono i pazienti, quanto dura il percorso.' },
            { path: '/sistema-ts', Icona: Landmark, titolo: 'Tessera Sanitaria',
              testo: 'Spese trasmesse all\u2019Agenzia delle Entrate, e quelle che non sono partite.' },
        ],
    },
];

const Amministrazione = () => {
    const navigate = useNavigate();

    return (
        <div className="amm-wrap">
            <h1>Amministrazione</h1>

            {VOCI.map((g) => (
                <section key={g.gruppo} className="amm-gruppo">
                    <h2>{g.gruppo}</h2>
                    <div className="amm-riquadri">
                        {g.voci.map((v) => (
                            <button
                                key={v.titolo}
                                className={`amm-riquadro ${v.inArrivo ? 'in-arrivo' : ''}`}
                                onClick={() => v.path && navigate(v.path)}
                                disabled={!v.path}
                            >
                                <v.Icona size={22} strokeWidth={1.6} />
                                <b>{v.titolo}</b>
                                <span>{v.testo}</span>
                                {v.inArrivo && <em>in preparazione</em>}
                            </button>
                        ))}
                    </div>
                </section>
            ))}
        </div>
    );
};

export default Amministrazione;
